import electronBridge from '../utils/electronBridge';
import { checkOfflineServersAvailable } from './offlineModelService';

const OFFLINE_ACCOUNT_KEY = 'offlineAccount';

const OFFLINE_ACCOUNT_DETAILS = {
    id: 'offline-local',
    accountNo: 'offline-local',
    accountTypeId: '0',
    username: 'Local User',
    email: '',
    isOfflineAccount: true,
    tokens: null,
};

export const getOfflineAccountDetails = () => ({ ...OFFLINE_ACCOUNT_DETAILS });

export const isOfflineAccount = (accountDetails) =>
    accountDetails?.isOfflineAccount === true;

export const canActivateOfflineAccount = async () => {
    if (!electronBridge.isElectron) return false;

    try {
        const { available } = await checkOfflineServersAvailable(2000);
        return available;
    } catch {
        return false;
    }
};

export const persistOfflineAccount = () => {
    try {
        localStorage.setItem(OFFLINE_ACCOUNT_KEY, JSON.stringify(OFFLINE_ACCOUNT_DETAILS));
    } catch (error) {
        console.error('[OfflineAccount] Failed to persist:', error);
    }
};

export const getPersistedOfflineAccount = () => {
    try {
        const stored = localStorage.getItem(OFFLINE_ACCOUNT_KEY);
        if (stored) return JSON.parse(stored);
    } catch (error) {
        console.error('[OfflineAccount] Failed to read persisted account:', error);
    }
    return null;
};

export const clearPersistedOfflineAccount = () => {
    try {
        localStorage.removeItem(OFFLINE_ACCOUNT_KEY);
    } catch (error) {
        console.error('[OfflineAccount] Failed to clear:', error);
    }
};
